import { render, staticRenderFns } from "./EstablishmentInternalOrderMailModalContent.vue?vue&type=template&id=463e7705"
import script from "./EstablishmentInternalOrderMailModalContent.vue?vue&type=script&lang=js"
export * from "./EstablishmentInternalOrderMailModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports